<template>
  <div class="page-container contact-page">
    <div class="container">
      <!-- 抖音号qrcode -->
      <el-image class="douyin-qrcode"
            :src='douyin_qrcode'
            fit="contain"></el-image>
      <!-- 微信公众号qrcode -->
      <el-image class="wechat-qrcode"
            :src='wechat_qrcode'
            fit="contain"></el-image>
    </div>
    <div class="info_area">
      <span class="info_title">邮箱：191389703@qq.com</span>
      <span class="info_title">微信号：HarryLee_39</span>
    </div>
  </div>
</template>

<script>
import douyin_qrcode from "@/assets/douyin_qrcode.jpeg";
import wechat_qrcode from "@/assets/wechat_qrcode.png";
export default {
  name: 'contact',
  components: {
  },
  data() {
    return {
      douyin_qrcode,wechat_qrcode,

    }
  },
  components: {
  },
  mounted() {
  },

  setup() {
  }
}
</script>

<style scoped>
.contact-page {
  background-color: #424245;
}
.douyin-qrcode {
  margin: 12px auto;
  width: 30vw;
  border-radius: 8px;
}
.wechat-qrcode {
  width: 30vw;
  margin: 0 auto 12px;
}
.info_area {
  width: 100%;
  height: 100%;
  /* background-color: orange; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
}

.info_title {
  font-size: 20px;
  color: #E8E8ED;
  text-align: left;
  text-align: left;
  line-height: 30px;
  font-weight: 300;
  /* background-color: red; */
}
</style>
